import type { I18nFn } from '#/i18n/types/I18nFn';

export function PROFILE_FLAGGING_REASONS(i18n: I18nFn) {
  return [
    {
      id: 'SCAM_SPAM',
      description: i18n('This is a scam/spam'),
    },
    {
      id: 'ILLEGAL_INCITES',
      description: i18n('This is illegal/incites hate'),
    },
    {
      id: 'IMAGE',
      description: i18n('The profile image is inappropriate'),
    },
    {
      id: 'CONTENT',
      description: i18n('The profile content is inappropriate'),
    },
    {
      id: 'BLOCKED_USER',
      description: i18n('User was blocked by another user'),
    },
    {
      id: 'OTHER',
      description: i18n('Other'),
    },
  ];
}
